// extracted by mini-css-extract-plugin
export var Button = "Button-module--Button--3UXex";
export var fullWidth = "Button-module--fullWidth--2Zy0l";
export var primary = "Button-module--primary--36M_E";
export var Spinner = "Button-module--Spinner--2xwAt";
export var secondary = "Button-module--secondary--TOn1A";
export var light = "Button-module--light--3Hpkk";
export var lightSecondary = "Button-module--lightSecondary--pH6Gl";
export var loading = "Button-module--loading--2YW_l";
export var ButtonInnerFlex = "Button-module--ButtonInnerFlex--2TM30";